import { Card, CardContent } from '@/components/ui/card';
import { Database, Package, AlertTriangle, ArrowLeftRight } from 'lucide-react';
import { useSyncSummary, useUnmatchedProducts } from '@/hooks/useInventorySyncReport';
import { format, parseISO } from 'date-fns';
import { Skeleton } from '@/components/ui/skeleton';

export function SyncStatusCards() {
  const { data: summary, isLoading } = useSyncSummary();
  const { data: unmatched } = useUnmatchedProducts();

  if (isLoading) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[...Array(4)].map((_, i) => (
          <Card key={i}><CardContent className="p-6"><Skeleton className="h-16" /></CardContent></Card>
        ))}
      </div>
    );
  }

  const cards = [
    {
      title: 'Last B2B Sync',
      value: summary?.lastB2BSyncDate
        ? format(parseISO(summary.lastB2BSyncDate), 'MMM dd, yyyy')
        : 'No data',
      subtitle: `${summary?.lastB2BSyncCount || 0} records`,
      icon: Database,
      color: 'text-blue-500',
    },
    {
      title: 'Last ChipChip Sync',
      value: summary?.lastChipChipSyncDate
        ? format(parseISO(summary.lastChipChipSyncDate), 'MMM dd, yyyy')
        : 'No data',
      subtitle: `${summary?.lastChipChipSyncCount || 0} records`,
      icon: Package,
      color: 'text-green-500',
    },
    {
      title: 'Unmatched Products',
      value: unmatched?.length || 0,
      subtitle: 'Need product mapping',
      icon: AlertTriangle,
      color: (unmatched?.length || 0) > 0 ? 'text-amber-500' : 'text-green-500',
    },
    {
      title: "Today's Movements",
      value: summary?.todayMovements || 0,
      subtitle: 'Inventory transactions',
      icon: ArrowLeftRight,
      color: 'text-purple-500',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card) => (
        <Card key={card.title}>
          <CardContent className="p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-muted-foreground">{card.title}</p>
                <p className="text-2xl font-bold mt-1">{card.value}</p>
                <p className="text-xs text-muted-foreground mt-1">{card.subtitle}</p>
              </div>
              <card.icon className={`h-8 w-8 ${card.color}`} />
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
